import { data } from '../../svg/PreviousProvider/data';
import { makeIcon } from '../makeIcon';

export const PreviousProvider = makeIcon(data, 'previous_provider', 'PreviousProvider');

export default PreviousProvider;
